import React from 'react'

class InProgress extends React.Component {
  render() {
    return (
      <svg className="inProgress" width="24" height="24" viewBox="0 0 24 24">
        <g fill="#1b66b3" fillRule="nonzero">
          <path
            d="M12 23.327c6.256 0 11.327-5.071 11.327-11.327S18.256.673 12 .673.673 5.744.673 12 5.744 23.327 12 23.327zm0-.5C6.02 22.827 1.173 17.98 1.173 12 1.173 6.02 6.02 1.173 12 1.173c5.98 0 10.827 4.847 10.827 10.827 0 5.98-4.847 10.827-10.827 10.827z"
            opacity=".5"
          />
          <path d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0v2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12H0z" />
        </g>
      </svg>
    )
  }
}

export default InProgress
